import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ChallanFormModal from "./AddChallans";
import MasterViewController from "../../redux/actions/masterApiActions";
import ExportButton from "../../components/ag grid/ExportButton";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";

import "../../styles/styles.css";
import "../../styles/layout.css";
import usePermission from "../../utils/usePermission";
import { getUserInfoFromToken } from "../../utils/authUtils";

const ChallanMasterList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  // const userType = localStorage.getItem("user_type");
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editChallan, setEditChallan] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const { hasPermission } = usePermission();
  const { getChallanMaster, deleteDepartment } = MasterViewController();
  const { challans } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(getChallanMaster());
  }, [dispatch]);

  const formikRef = useRef();
                  useEffect(() => {
                  const { userType, userId } = getUserInfoFromToken();
                  setUserType(userType);
                  setUserId(userId);
                }, []);

  const handleDelete = (id) => dispatch(deleteDepartment(id));
  const handleEdit = (challans) => {
    setEditChallan(challans);
    setShowModal(true);
  };

  

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Name",
      field: "name",
      flex: 1,
    },
    {
      headerName: "Amount",
      field: "amount",
      flex: 1,
    },
    {
      headerName: "Percentage ",
      field: "percentage",
      flex: 1,
    },
    {
      headerName: "Applicable Component" ,
      field: "applicable_salary_component",
      flex: 1,
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
         {(userType === "Admin"||hasPermission("challan_master", "edit"))&&(
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
         )}
         {hasPermission("challan_master", "delete")&&(
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
         )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex flex-wrap  mb-3" style={{ justifyContent: "space-between" }}>
        <div className="mt-2" >
        {( userType === "Admin"|| hasPermission("challan_master", "create"))&& (
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => {
            setEditChallan(null);
            setShowModal(true);
          }}
          sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",       
                       
            }}
        >
          Add Challan
        </Button>
        )} 
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div>
          {( userType === "Admin"|| hasPermission("challan_master", "export")) && (
            <ExportButton
              gridRef={gridRef}
              fileName="challans.xlsx"
              exportColumns={["name"]}
              disabled={selectedRows.length === 0}
            />
          )}
          </div>
        <PageSizeSelector
          pageSize={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        />
        
        </div>
      </div>

      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Challan List</h3>
          </Col>
        </Row>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={challans}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <ChallanFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editChallan}
      />
    </div>
  );
};

export default ChallanMasterList;











